import React from 'react';

export const NeighbourhoodIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-288.2 413.4 14.8 14.7" {...props}>
    <path d="M-280.7 413.4c-2.4 0-4.4 2-4.4 4.4 0 2.3 4 8.4 4.2 8.7.1.1.1.1.3.1.1 0 .2-.1.3-.1.2-.3 4.2-6.3 4.2-8.7-.2-2.5-2.2-4.4-4.6-4.4zm-.1 6.6c-1.3 0-2.4-1.1-2.4-2.4 0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4c0 1.3-1.1 2.4-2.4 2.4z" />
    <path d="M-280.8 428.1c-1.7 0-7.4-.1-7.4-1.7 0-.4 0-1.2 4.3-1.6.3 0 .5.2.5.5s-.2.5-.5.5c-1.8.2-2.8.4-3.2.6.7.3 2.8.7 6.2.7 3.3 0 5.5-.4 6.2-.7-.4-.2-1.4-.4-3.2-.6-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5 4.4.4 4.4 1.2 4.4 1.6.1 1.6-5.6 1.7-7.3 1.7z" />
  </svg>
);
